export default "__VITE_ASSET__C1KaK4Vo__"